import type { ReactNode } from "react";
import type { IntlShape } from "react-intl";
import { getBankAccountMasksAsString } from "shared-ui";

import { AIR_MESSAGES } from "../message-definitions";

export type ReconnectionStep =
  | "reconnect_connection_landing"
  | "cannot_reconnect_bank"
  | "upload_bank_statements"
  | "cannot_reconnect_connection"; // non-banking connection

/**
 * The instruction on the bank-statement upload step. Extracted so the mask-count and
 * missing-bank-name branches can be asserted without mounting the upload form.
 */
export const getBankStatementUploadInstruction = (
  intl: IntlShape,
  { bankName, bankAccountMasks, period }: { bankName?: string | null; bankAccountMasks?: string[]; period: ReactNode }
): ReactNode => {
  if ((bankAccountMasks?.length ?? 0) === 0) {
    return intl.formatMessage(
      {
        id: "funding-application: air reconnect bank statement required plus period description  (no mask)",
        defaultMessage: "Please upload statements for your {bankName} bank for the period {period}",
      },
      { bankName: bankName ? bankName : "", period }
    );
  }

  return intl.formatMessage(
    {
      id: "funding-application: air reconnect bank statement required accounts plus period description (with masks)",
      defaultMessage:
        "Please upload statements for your {bankName} {noBankAccountMasks, plural, =1 {account} other {accounts}} ending in {bankAccountMasks} for the period {period}",
    },
    {
      bankName: bankName ? bankName : intl.formatMessage(AIR_MESSAGES.bankStatementDefaultBankName),
      noBankAccountMasks: bankAccountMasks?.length,
      bankAccountMasks: getBankAccountMasksAsString(intl, bankAccountMasks ?? []),
      period,
    }
  );
};
